import { AUTH_MEMBER_FRAGMENT } from 'containers/app/beforeRoutes/AuthenticateFromToken/authentication-query';
import gql from 'graphql-tag';

export const MEMBER_CREATE_QUERY = gql`
  mutation CreateMember($member: MemberCreateInput) {
    createMember(member: $member) {
      id
      firstName
      lastName
      username
      customField1
      customField2
      customField3
      customField4
      customField5
    }
  }
`;

export const MEMBER_UPDATE_MUTATION = gql`
  mutation updateMember($member: MemberUpdateInput) {
    updateMember(member: $member) {
      id
      firstName
      lastName
      username
      customField1
      customField2
      customField3
      customField4
      customField5
    }
  }
`;

export const ACTIVE_MEMBER_UPDATE_MUTATION = gql`
  mutation UpdateActiveMember($member: MemberUpdateInput) {
    updateMember(member: $member) {
      ...AuthMember
    }
  }
  ${AUTH_MEMBER_FRAGMENT}
`;
